import { isNonEmptyString } from '@thesavingsgroup/utils/isNonEmptyString';
import { StateCreator } from 'zustand';

import { CookieState } from './types/CookieState';
import { CookieStateDependencies } from './types/CookieStateDependencies';

export const cookieStore =
  ({ Cookies }: CookieStateDependencies): StateCreator<CookieState> =>
  () => ({
    computed: {
      get allCookies(): Record<string, string> {
        return Cookies.get();
      },

      get googleVisitorId(): string {
        const _ga = Cookies.get('_ga');
        const __utma = Cookies.get('__utma');

        // The GA4 JavaScript tags use first-party cookies to distinguish unique
        // users as well as unique sessions from a single user. This cookie’s
        // value is composed of several components separated by a dot: Google
        // Analytics 4 version, Domain level, Random number, Cookie created timestamp
        if (isNonEmptyString(_ga)) {
          const parts = _ga.split('.');
          return `${parts[2]}.${parts[3]}`;
        }

        // __utma is a persistent cookie that expires in 2 years from the last update.
        // The content of this cookie value is separated by a dot, and stores
        // domain hash, random ID, time of first visit, time of last visit,
        // time of current visit, and session counter
        if (isNonEmptyString(__utma)) {
          const parts = __utma.split('.');
          return `${parts[1]}.${parts[2]}`;
        }

        return '';
      },
    },

    getByName(name: string): string | undefined {
      return Cookies.get(name);
    },

    has(name: string): boolean {
      // From RFC 6265, Section 5.2:
      // The (possibly empty) name string consists of the characters up to, but
      // not including, the first %x3D ("=") character, and the (possibly empty)
      // value string consists of the characters after the first %x3D ("=") character.
      //
      // However, in order to avoid edge cases, we treat a cookie with an empty
      // value as non-existent
      return isNonEmptyString(Cookies.get(name));
    },
  });
